<template>
  <div class="InputGroup InputGroup--checkbox">
    <label v:for="id" class="InputGroup__label">
      {{ label }}<slot></slot>
      <input :id="id" type="checkbox" :disabled="readonly" :required="required" :checked="value" @input="$emit('input', $event.target.checked)" />
      <div class="InputGroup__switch"></div>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.InputGroup {
  &__label {
    max-width: 25rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__switch {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    font-size: 10px;
    width: 4em;
    height: 2.2em;
    border-radius: 1.375rem;
    border: 1px solid $color-grey;
    background-color: #fff;
    transition: all 0.1s ease-in-out;

    &::before {
      content: '';
      display: inline-block;
      width: 1.8em;
      height: 1.8em;
      position: absolute;
      top: 0;
      left: 0;
      margin: 1px;
      border-radius: 50%;
      background-color: $color-grey;
      transition: all 0.1s ease-in-out;
    }
  }

  input {
    display: none;
  }

  input:checked + &__switch {
    border-color: #fff;
    background-color: $color-primary;

    &::before {
      background-color: #fff;
      transform: translateX(100%);
    }
  }
}
</style>
